import type { Map as MapType } from "maplibre-gl";
import type { SiloPlatform } from "../../types";

export class SilosRenderer {
  constructor(private map: MapType) {}

  /**
   * 🌟 LIGHTWEIGHT MATCHING LOOKUP: Instantly provides pre-loaded WebGL textures
   */
  async createMarker(
    platform: SiloPlatform,
    isSelected: boolean,
  ): Promise<string> {
    const targetIcon = platform.icon ?? platform.type ?? "ship";
    const selectedState = isSelected ? "selected" : "deselected";

    // Assembles lookups matching the atlas keys: e.g. "ship-selected" or "truck-deselected"
    return `${targetIcon}-${selectedState}`;
  }

  hasMarker(markerId: string): boolean {
    return this.map.hasImage(markerId);
  }

  clearCache() {
    // Left empty: Memory allocation is handled entirely by the root map engine style hooks
  }

  destroy() {
    // Handled at application layer teardown
  }
}
